import { useTheme } from '@/hooks/useTheme';
import { SV_COLORS, type SvPalette } from '@/lib/stationVolumes/tokens';

/**
 * The station-volumes palette for the theme the app is CURRENTLY in.
 *
 * The 2D dock draws with `var(--sv-*)`, which the browser re-resolves on its
 * own when `<html>` flips between `light` and `dark`. Three.js materials
 * cannot read custom properties, so anything drawn in the scene — the band
 * colours, the stale-alignment silhouette, the hover/walk outlines — has to be
 * handed plain hex, and that hex has to change with the theme or a light-mode
 * user gets the dark ramp on a white sky (which is what shipped).
 *
 * `useTheme` is the app's single source of truth for the theme: it reads the
 * user's stored preference (`userThemeAtom`) and falls back to
 * `prefers-color-scheme`, and `providers/index.tsx` drives the `<html>` class
 * from the very same value. So this subscribes to the *cause*, not to the
 * class attribute it produces — no `MutationObserver`, and no frame where the
 * scene and the dock disagree.
 */
export const useSvPalette = (): SvPalette => SV_COLORS[useTheme()];
